import { useAppContext } from '../../context/AppContext';
import { updateUserProfile } from '../../services';
import React, { useState, useEffect } from 'react';

function Toggle({ id, checked, onChange, label, description }) {
  return (
    <div className="toggle-row">
      <div className="toggle-info">
        <div className="toggle-label">{label}</div>
        {description && <div className="toggle-desc">{description}</div>}
      </div>
      <label className="toggle" htmlFor={id}>
        <input id={id} type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} />
        <span className="toggle-slider" />
      </label>
    </div>
  );
}

export const NotificationSettings = () => {
  const { user, setUser, token, base_url, showStatus } = useAppContext();
  const [loading, setLoading] = useState(false);
  const [notificationPreferences, setNotificationPreferences] = useState({
    send_event_alert: true,
    send_error_alert: true,
    send_daily_activity_summary: true
  });

  useEffect(() => {
    if (user) {
      setNotificationPreferences({
        send_event_alert: user.send_event_alert ?? true,
        send_error_alert: user.send_error_alert ?? true,
        send_daily_activity_summary: user.send_daily_activity_summary ?? true
      });
    }
  }, [user]);

  const handleSaveNotifications = async () => {
    setLoading(true);
    try {
      const response = await updateUserProfile(token, base_url, {
        send_event_alert: notificationPreferences.send_event_alert,
        send_error_alert: notificationPreferences.send_error_alert,
        send_daily_activity_summary: notificationPreferences.send_daily_activity_summary
      });
      setUser(response.user);
      showStatus('success', 'Notification preferences updated successfully!');
    } catch (error) {
      showStatus('error', error.message || 'Failed to update notification preferences');
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return <p className="form-hint">Loading notification settings…</p>;
  }

  return (
    <div>
      <div className="step-header">
        <h2>Notifications</h2>
        <p>Choose which email notifications you would like to receive.</p>
      </div>

      <div className="form-section">
        <Toggle
          id="send_event_alert"
          checked={notificationPreferences.send_event_alert}
          onChange={(checked) => setNotificationPreferences(prev => ({ ...prev, send_event_alert: checked }))}
          label="Successful Events"
          description="Receive real-time alerts when events are successfully processed."
        />
        <Toggle
          id="send_error_alert"
          checked={notificationPreferences.send_error_alert}
          onChange={(checked) => setNotificationPreferences(prev => ({ ...prev, send_error_alert: checked }))}
          label="Errors"
          description="Receive real-time alerts when errors occur in your workflows."
        />
        <Toggle
          id="send_daily_activity_summary"
          checked={notificationPreferences.send_daily_activity_summary}
          onChange={(checked) => setNotificationPreferences(prev => ({ ...prev, send_daily_activity_summary: checked }))}
          label="Activity Summaries"
          description="Receive weekly summaries of your account activity and performance."
        />
      </div>

      <button
        type="button"
        className="btn btn-primary"
        onClick={handleSaveNotifications}
        disabled={loading}
      >
        {loading ? 'Saving…' : 'Save Preferences'}
      </button>
    </div>
  );
};
